import { API_BASE_URL } from "../../config/config";
import { LeadDTO, LeadFileClient, LeadFileDTO } from "../../services/apiClient";
import axiosInstance from "../../services/axiosInstance";

const leadFileApiClient = new LeadFileClient(API_BASE_URL, axiosInstance);

export const handleFileSubmit = async (lead: LeadDTO | undefined, uploadFiles: LeadFileDTO[]) => {
  try {
    if (lead && uploadFiles && uploadFiles.length > 0) {
      await Promise.all(
        uploadFiles.map((fileToDb) => {
          fileToDb.leadId = lead.id;
          leadFileApiClient.createLeadFile(fileToDb);
        }
      ));
    }
  } catch (error) {
    console.error('Error submitting files:', error);
  }
};
